/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const CreativeApproval56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M12 14a8 8 0 110 16 8 8 0 010-16zM36 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4z"
            />
            <path fill={vars.white} d="M16 8h25a3 3 0 013 3v33a3 3 0 01-3 3H13V11a3 3 0 013-3z" />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M41 6a4.999 4.999 0 014.995 4.783L46 11v32a4.999 4.999 0 01-4.783 4.995L41 48H10c-2.21 0-4-1.79-4-4v-6h6V11a4.999 4.999 0 014.783-4.995L17 6h24zM14 44c0 .729-.195 1.413-.536 2.001L41 46a3 3 0 002.995-2.824L44 43V11a3 3 0 00-2.824-2.995L41 8H17a3 3 0 00-2.995 2.824L14 11zm-2-4H8v4c0 1.054.816 1.918 1.85 1.995L10 46a2 2 0 002-2v-4z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M26.5 39a.5.5 0 010 1h-4a.5.5 0 010-1h4zm3-3a.5.5 0 010 1h-7a.5.5 0 010-1h7zm4-3a.5.5 0 010 1h-11a.5.5 0 010-1h11zm.5-17c1.054 0 1.918.816 1.995 1.85L36 18v9a2.001 2.001 0 01-1.85 1.995L34 29H24a2.001 2.001 0 01-1.995-1.85L22 27v-9c0-1.054.816-1.918 1.85-1.995L24 16h10zm0 1H24a1 1 0 00-.993.883L23 18v7c1.9-2.11 2.98-3.313 3.243-3.61.393-.444.984-.522 1.408-.138a.956.956 0 01.119.127l3.128 3.506a433.37 433.37 0 001.345-1.5c.393-.444.984-.522 1.408-.139.043.04.083.082.119.128l1.231 1.38L35 18a1 1 0 00-1-1zm-3 2a1 1 0 110 2 1 1 0 010-2z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M8 40h4v4a2 2 0 01-2 2l-.15-.005A2.001 2.001 0 018 44v-4zm30.52-4c-.498 0-.926.35-1.027.837L36.638 41h-4.507a2 2 0 00-1.952 2.434l1.111 5A2 2 0 0033.243 50H44v-2l1.5-1-1.5-2v-4h-2.362l-1.912-4.222A1.323 1.323 0 0038.52 36z"
            />
            <path fill={vars.white} d="M45 50h2a1 1 0 001-1v-7a1 1 0 00-1-1h-2v9z" />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M47 39a3 3 0 012.995 2.824L50 42v7a3 3 0 01-2.824 2.995L47 52H33.243a4 4 0 01-3.905-3.132l-1.111-5a3.96 3.96 0 01-.096-.868l.005-.2a4 4 0 013.995-3.8h2.876l.527-2.566A3.049 3.049 0 0138.52 34l.205.006a3.325 3.325 0 012.823 1.947L42.928 39H47zm-8.48-3c-.498 0-.926.35-1.027.837L36.638 41h-4.507a2 2 0 00-1.952 2.434l1.111 5A2 2 0 0033.243 50h10.756v-9h-2.36l-1.913-4.222A1.323 1.323 0 0038.52 36zM47 41h-2v9h2a1 1 0 00.993-.883L48 49v-7a1 1 0 00-.883-.993L47 41z"
            />
        </g>
    </AccessibleSVG>
);

export default CreativeApproval56;
